<template>
  <div class="landing-page">
    <div class="landing-content text-center">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8 text-center">
            <img src="@/assets/img/logo.svg" alt="Shareguard Logo" class="navbar-brand-img mx-auto" style="max-width: 320px; width: 80%;" />
            <p class="lead">Secure file sharing made simple</p>
            
            <!-- Dynamic message based on landing reason -->
            <div  v-if="landingReason" class="alert bg-shareguard text-white mb-5">
              <template v-if="landingReason === 'file-share'">
                <h4 class="text-white">You've received a file!</h4>
                <p class="text-white">Please log in to access your shared file.</p>
              </template>
              <template v-else-if="landingReason === 'email-notification'">
                <h4 class="text-white">New files shared with you</h4>
                <p class="text-white">Log in to view the files shared with you.</p>
              </template>
              <template v-else-if="landingReason === 'invite-email'">
                <h4 class="text-white">You have been invited!</h4>
                <p class="text-white">{{ email }} wants to securely share a file with you, sign up to get started.</p>
              </template>
              <template v-else>
                <h4 class="text-white">Welcome to ShareGuard</h4>
                <p class="text-white">Get started by creating an account or logging in.</p>
              </template>
            </div>

            <!-- Features Section -->
            <!-- <div class="features-section mb-5">
              <h2 class="mb-4">Why Choose Shareguard?</h2>
              <div class="row">
                <div class="col-md-4">
                  <div class="feature-card">
                    <i class="fas fa-shield-alt fa-3x mb-3"></i>
                    <h4>Secure Sharing</h4>
                    <p>End-to-end encryption for your files</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="feature-card">
                    <i class="fas fa-bolt fa-3x mb-3"></i>
                    <h4>Fast Transfer</h4>
                    <p>Quick and reliable file delivery</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="feature-card">
                    <i class="fas fa-users fa-3x mb-3"></i>
                    <h4>Easy Collaboration</h4>
                    <p>Share with anyone, anywhere</p>
                  </div>
                </div>
              </div>
            </div> -->

            <!-- Subscription Options -->
            <!-- <div class="subscription-section mb-5">
              <h2 class="mb-4">Choose Your Plan</h2>
              <div class="row">
                <div class="col-md-6">
                  <div class="card subscription-card">
                    <div class="card-body">
                      <h3>Free Plan</h3>
                      <ul class="list-unstyled">
                        <li>✓ Up to 5GB storage</li>
                        <li>✓ Basic file sharing</li>
                        <li>✓ Standard support</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="card subscription-card premium bg-shareguard text-white">
                    <div class="card-body">
                      <h3 class="text-white">Premium Plan</h3>
                      <ul class="list-unstyled">
                        <li>✓ Unlimited storage</li>
                        <li>✓ Advanced security features</li>
                        <li>✓ Priority support</li>
                        <li>✓ Custom branding</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->

            <!-- Action Buttons -->
            <div class="action-buttons">
              <!-- Left button -->
              <button  v-if="landingReason === 'invite-email'" class="btn btn-shareguard btn me-3" @click="handleRegister">
                Create Account
              </button>
              <button v-else-if="landingReason === 'file-share'" class="btn btn-shareguard btn me-3" @click="handleLogin">
                Login to View File
              </button>
              <button v-else class="btn btn-shareguard btn me-3" @click="handleLogin">
                Login
              </button>

              <!-- Right button -->
              <button v-if="landingReason === 'invite-email'" class="btn btn-outline-shareguard btn" @click="learnMore">
                Learn More
              </button>
              <button v-else-if="landingReason === 'file-share'" class="btn btn-outline-shareguard btn" @click="handleRegister">
                Create Account
              </button>
              <button v-else class="btn btn-outline-shareguard btn" @click="handleRegister">
                Create Account
              </button>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { initializeMsal } from "@/plugins/msal";

export default {
  name: "LandingPage",
  data() {
    return {
      landingReason: null,
      isFileShare: false,
      email: null
    };
  },
  created() {
    // Check URL parameters for landing reason
    const params = new URLSearchParams(window.location.search);
    this.landingReason = params.get('reason');
    if(this.landingReason === 'file-share') {
      this.isFileShare = params.get('fileId') !== null;

    } else if(this.landingReason === 'invite-email') {
      this.isFileShare = false;
      this.email = params.get('fileId');
    }
  },
  methods: {
    learnMore() {
      window.location.href = 'https://shareguard.me';
      return;
    },

    async handleLogin() {
      console.log('🔑 LandingPage - handleLogin called');
      const instance = await initializeMsal();
      if (instance) {
        // Log the current redirect path if it exists
        const currentRedirect = sessionStorage.getItem('redirectAfterUnlock');
        console.log('🔍 LandingPage - Current redirect path:', currentRedirect);
        
        // Always redirect to /unlock after login
        console.log('🔑 LandingPage - Initiating login redirect to /unlock');
        await instance.loginRedirect({
          redirectStartPage: '/unlock'
        });
      }
    },
    async handleRegister() {
      const instance = await initializeMsal();
      if (instance) {
        // Log the current redirect path if it exists
        const currentRedirect = sessionStorage.getItem('redirectAfterUnlock');
        console.log('🔍 LandingPage - Current redirect path:', currentRedirect);
        
        // Always redirect to /unlock after registration
        await instance.loginRedirect({ 
          prompt: 'select_account',
          redirectStartPage: '/unlock'
        });
      }
    }
  }
};
</script>

<style scoped>
.landing-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.landing-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.feature-card {
  padding: 2rem;
  text-align: center;
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 1rem;
}

.subscription-card {
  padding: 2rem;
  text-align: center;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.subscription-card:hover {
  transform: translateY(-5px);
}

.action-buttons {
  margin-top: 3rem;
}

.alert {
  border-radius: 10px;
  padding: 1.5rem;
}
</style> 